<div class="page-description-section">
    <div appLocalizationPopupDirective localizationCode="Adp-SchedulesPageDescription">
        {{ 'Adp-SchedulesPageDescription' | translate: {Default: "Configure the times of day the Adp import should run. Each schedule can be individually updated, deleted, enabled or disabled."} }}
    </div>
</div>

<app-data-grid-comp
    [columns]="columns"
    [gridDataResult]="gridDataResult"
    category="AdpSchedules"
    [rowActionButtons]="gridActionButtons"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [searchable]="false"
    [filter]="null"
    [filterable]="null"
    [filterCategories]="null"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    (emitOpenDialogEvent)="openDialog($event)"
    (emitDeleteEvent)="deleteAllSelected($event)"
    (rowActionEvent)="onRowAction($event)"
></app-data-grid-comp>
